// extracted by mini-css-extract-plugin
export default {"button":"style_button__q+iZE","fullWidth":"style_fullWidth__N9hHZ","black":"style_black__8Hw6B","white":"style_white__2wkYF","noborder":"style_noborder__qkJnS"};